import { getToken } from '../Commons/Authentication'
import * as request from 'superagent'
import store from '../Commons/store'
import moment from 'moment'
export function planesFunction (identification) {

    request
    .get('api/v1/plan/?numeroDocumento=' + identification)
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
        if (err) {
            console.log(err)
        }
        if (res) {
            // console.log(res.body)
            if (res.body.length > 0) {
                let planes = res.body.map((plan, id) => {
                    var d = moment(plan.timestamp, 'x').format('[Fecha: ]DD-MM-YYYY HH:mm')
                    return { text: plan.text, fecha: d, responsable: `Responsable: ${plan.userCreated[0].nombres} ${plan.userCreated[0].apellidos}` }
                })
                const action = {
                    type: 'add_planes',
                    planes: planes
                  }
                  store.dispatch(action)
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/components/PrintableDashboard/planesAction.js